import moment from 'moment'
import { ListFormControl } from '../../sections/ListForm'
import ControlRequest from '../../utilities/ControlRequest'
import FormEvents from '../../utilities/FormEvents'
import { Keys } from './constants'
import { StoragePage, Form, LogicalProductForInput } from './types'

export const storagePage: StoragePage = {
    inputPart: null,
    mode: 'creation',
    current_type_stowage_id_origin: null,
    current_stowage_origin_id: null,
    companies: [],
    symbol: '',
    timezone: ''
}

export const formInputPart = new FormEvents<Form>(Keys.FORM, {
    company: null,
    warehouse: null,
    stowage: null,
    tag: null,
    sub_stowage: null,
    request_date: moment().toISOString(),
    description: '',
    products: []
})

export const productsControl = new ListFormControl<LogicalProductForInput>(
    Keys.TABLE_PRODUCTS,
    [
        '#',
        'Producto',
        'Presentación',
        'Cantidad de entrada',
        'Valor de ingreso unitario',
        'Valor total de ingreso',
        'Acciones'
    ]
)

export const reqWarehouse = new ControlRequest()
export const reqStowage = new ControlRequest()
export const reqSubStowage = new ControlRequest()
export const reqProducts = new ControlRequest()
export const reqWorkingPeriod = new ControlRequest()
